import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function TopBar() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    console.log("Logout clicked");
    // later: logout logic
  };

  return (
    <Box
      sx={{
        height: 64,
        bgcolor: "#ffffff",
        borderBottom: "1px solid #e0e0e0",
        px: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      {/* Profile Section */}
      <Box
        onClick={handleOpen}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          gap: 1,
        }}
      >
        <Avatar
          src="/images/user-avatar.png" // optional, fallback works
          sx={{ width: 32, height: 32 }}
        />

        <Typography className="st-h3">
          Admin
        </Typography>

        <IconButton size="small">
          <KeyboardArrowDownIcon />
        </IconButton>
      </Box>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </Box>
  );
}
